module.exports = __webpack_public_path__ + "assets/img/home_p_2.128b68e5.png";